const result = {
  path: 'result',
  component: resolve => require(['../../../../components/pages/signUp/result'], resolve)
}
export default result



// WEBPACK FOOTER //
// ./src/router/pages/signUp/result/index.js